import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";

const GstLedgerReport = () => {
  const today = new Date().toISOString().split('T')[0];
  const [reportDate, setReportDate] = useState(today);
  const [invoices, setInvoices] = useState([]);

  const handleFetchData = async () => {
    try {
      const res = await axios.post("https://api.trucoo.in/ledger/master-ledger/", {
        date: reportDate
      }, {
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "erpTrucoo"
        }
      });

      if (res.data.status === 'success') {
        setInvoices(res.data.invoices || []);
      }
    } catch (err) {
      console.error("Error fetching ledger summary:", err.message);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [reportDate]);

  // Filter invoices with GST and calculate total GST
  const gstInvoices = invoices.filter(invoice => parseFloat(invoice.gst) > 0);
  const totalGST = gstInvoices.reduce((sum, invoice) => sum + parseFloat(invoice.gst), 0);
  const totalAmt = gstInvoices.reduce((sum, invoice) => sum + parseFloat(invoice.totalPayment), 0);

  const getFiscalYearLabel = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
  };

  const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <div className="row mt-3">
                  <div className="col-md-3"><h4 className="box-title">Liability Ledger</h4></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      value={reportDate}
                      onChange={(e) => setReportDate(e.target.value)}
                    />
                  </div>               
                </div>
              </div>
              <div className="box-body">
                <div className="table-responsive">
                  <table className="table-sm table-bordered fs-12" width="100%">
                    <thead className="thead-light">
                      <tr>
                        <th width="3%" className="text-center">S.No</th>
                        <th width="8%" className="text-center">Date</th>
                        <th width="10%" className="text-center">Invoice No</th>
                        <th width="8%" className="text-center">Vehicle No</th>
                        <th className="text-center">Dealer</th>
                        <th width="10%" className="text-center">Total Amount</th>
                        <th width="10%" className="text-center">GST Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gstInvoices.length > 0 ? (
                        <>
                          {gstInvoices.map((invoice, index) => (
                            <tr key={`invoice-${index}`}>
                              <td>{index + 1}</td>
                              <td>{formatViewDate(invoice.date)}</td>
                              <td>{`TRC/${invoice?.invoiceId}/${getFiscalYearLabel(new Date(invoice?.date))}`}</td>
                              <td>{invoice.vNum}</td>
                              <td>{invoice.dealerData?.dealer || 'N/A'}</td>
                              <td className="text-end">{Number(invoice.totalPayment).toFixed(2)}</td>
                              <td className="text-end">{Number(invoice.gst).toFixed(2)}</td>
                            </tr>
                          ))}
                          <tr>
                            <th colSpan="5" className="text-right">Total</th>
                            <th className="text-end">{totalAmt.toFixed(2)}</th>
                            <th className="text-end">{totalGST.toFixed(2)}</th>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">No invoices with GST found for this date.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default GstLedgerReport;